export const _LOAD_MODEL_ = 'Load:SampleModel';
export const _RELOAD_TYPE_ = 'Reload:SampleType';
export const _CLEAR_FILES_ = 'Reload:SampleFile';
export const _OPEN_MODAL_ = 'Open:SampleFile';
export const _LOAD_MODEL_MODAL_ = 'Load:ProductModel';
export const _RELOAD_SAMPLE_AGENT_ = 'Reload:SampleAgent';
export const _ADD_SAMPLE_AGENT_TAB_RESULT_ = 'Add:SampleAgent';
export const _ADD_SAMPLE_NEW_RESULT_TAB_RESULT_ = 'Add:SampleResult';
export const _DELETE_SAMPLE_RESULT_TAB_RESULT_ = 'Delete:SampleResult';

export const _DELETE_SAMPLE_ = 'Delete:Sample';

export const _SAVE_SAMPLE_SUCCESS_ = 'Save:SampleSuccess';

export const _FINISHED_SAVE_REQUEST_ = 'SaveRequest:Finished';

export const MODAL_TYPE = 'agents_modal';

export const CHARACTERIZATION = {
  sample_no: null,
  ghe: null,
  supervisor: null,
  employee: null,
  register: null,
  function: null,
  sector: null,
  equipment: null,
  files: [],
};

export const AUTOCOMPLETE_TYPES = [
  'agent_chemical',
  'dispersal',
];

export const MODEL = {
  id: null,
  created_at: null,
  updated_at: null,
  customer_id: null,
  company_city: null,
  company_name: null,
  f_created_at: null,
  quotation_id: null,
  quotation_row_id: null,
  ...{ CHARACTERIZATION },
  memory_field: null,
  risk_classification: null,
  result: null,
  validation: null,
  type_id: null,
  type: {
    name: null,
    slug: null,
  },
  images: [],
};

export const EPI_ROW = {
  id: null,
  type: null,
  model: null,
  number: null,
  manufacturer: null,
};

export const AGENT_ROW = {
  id: null,
  date: '',
  agent_id: null,
  agent: '',
  agent_code: '',
  agent_cas: '',
  agent_method: '',
  sampler_type: '',
  white_field_no: '',
  pump_flow: null,
  volume: null,
  temperature: null,
  initial_ura: null,
  atmospheric_pressure: null,
  initial: '',
  final: '',
  interval_initial: '',
  interval_final: '',
  total_time: '',
};

export const CHEMICAL_MEMORY = {
  instrument: null,
  instrument_object: null,
  instrument_serie: null,
  instrument_certificate: null,
  instrument_validity: null,
  gauge: null,
  gauge_object: null,
  gauge_serie: null,
  gauge_certificate: null,
  gauge_validity: null,
  date: null,
  agents: [{ ...AGENT_ROW }],
  epis: [{ ...EPI_ROW }],
  observation: null,
};

export const CHEMICAL_RESULT = {
  lq: null,
  mp: null,
  twa: null,
  ipvs: null,
  stel: null,
  osha: null,
  teto: null,
  code: null,
  unity: null,
  method: null,
  result: null,
  celling: null,
  bg_color: null,
  dispersal: null,
  risk_level: null,
  odor_limit: null,
  respirator: null,
  conclusion: null,
  notion_skin: null,
  agent_chemical: null,
  action_in_body: null,
  deviation_factor: null,
  size_aerodispersoides: null,
};

export const CHEMICAL_CLASSIFICATION = {
  recommendation: null,
  classifications: [
    {
      leo: null,
      index: null,
      frequency: null,
      agent_chemical: null,
    },
  ],
};

export const CHEMICAL_VALIDATION = {
  justify: null,
  variation: null,
  avaliation: null,
  calibration: null,
  sample_type: null,
  representative: null,
  varification_final: null,
  varification_initial: null,
};

export const NOISE_MEMORY = {
  data: null,
  sample: null,
  method: null,
  medition: null,
  noise_type: null,
  final_time: null,
  task: null,
  duration: null,
  initial_time: null,
  exposition_limit: null,
  final_calibration: null,
  initial_calibration: null,
  instrument: null,
  instrument_serie: null,
  instrument_certificate: null,
  instrument_validity: null,
  gauge: null,
  gauge_serie: null,
  gauge_certificate: null,
  gauge_validity: null,
  epis: [{ ...EPI_ROW }],
  observation: null,
};

export const NOISE_RESULT_FIELDS = {
  code: null,
  agent: null,
  method: null,
  result: null,
  lavg: null,
  leq: null,
  twa: null,
  nen: null,
  dose8: null,
  conclusion: null,
  bgColor: null,
};

export const NOISE_RESULT = {
  nho: { ...NOISE_RESULT_FIELDS },
  nr15: { ...NOISE_RESULT_FIELDS },
};

export const NOISE_CLASSIFICATION_FIELDS = {
  consideration: null,
  dose_daily: null,
  leo: null,
  recommended_action: null,
  bgColor: null,
};

export const NOISE_CLASSIFICATION = {
  nho: { ...NOISE_CLASSIFICATION_FIELDS },
  nr15: { ...NOISE_CLASSIFICATION_FIELDS },
  recomendation: null,
};

export const NOISE_VALIDATION = {
  avaliation: null,
  exposition: null,
  exposition_type: null,
  justify: null,
};

export const VIBRATION_MEMORY = {
  data: null,
  medition: null,
  final_time: null,
  initial_time: null,
  sample: null,
  vibration_type: null,
  method: null,
  criterion: null,
  criterion_1: null,
  component: null,
  exposition_time: null,
  cycle: null,
  sample_time: null,
  repeat_number: null,
  vibration_font: null,
  frequency: null,
  brand: null,
  model: null,
  equipment_year: null,
  bank_type: null,
  tire_type: null,
  floor_type: null,
  operating_speed: null,
  instrument: null,
  instrument_serie: null,
  instrument_certificate: null,
  instrument_validity: null,
  epis: [{ ...EPI_ROW }],
  observation: null,
};

export const VIBRATION_RESULT = [
  {
    norm: null,
    criterion: null,
    result: null,
    limit: null,
  },
  {
    norm: null,
    criterion: null,
    result: null,
    limit: null,
  },
];

export const VIBRATION_CLASSIFICATION = {
  vdvr: null,
  aren: null,
  consideration: null,
  recomendation: null,
  exposition_recomendation: null,
};

export const VIBRATION_VALIDATION = {
  avaliation: null,
  exposition: null,
  sample_type: null,
  justify: null,
};

export const TASK_HEAT = {
  task: null,
  ura: null,
  initial: null,
  final: null,
  duration: null,
  metabolism: null,
  activity_type: null,
  var: null,
  tbs: null,
  tbn: null,
  tg: null,
  ibutg: null,
};

export const HEAT_MEMORY = {
  instrument: null,
  instrument_serie: null,
  instrument_certificate: null,
  instrument_validity: null,
  medition: null,
  sample: 'Calor IBUTG',
  method: 'nho06',
  exposition_limit: null,
  tasks: [{ ...TASK_HEAT }],
  epis: [{ ...EPI_ROW }],
  observation: null,
};

export const HEAT_RESULT = {
  metabolism: null,
  ibutg: null,
  action_level: null,
  max: null,
};

export const HEAT_CLASSIFICATION = {
  condition: null,
  consideration: null,
  recomendation: null,
  exposition_recomendation: null,
};

export const HEAT_VALIDATION = {
  avaliation: null,
  exposition: null,
  sample_type: null,
  justify: null,
  initial: null,
  initial_tbs: null,
  initial_tbn: null,
  initial_tg: null,
  final: null,
  final_tbs: null,
  final_tbn: null,
  final_tg: null,
  stabilization: null,
  equipment: null,
};
